export enum FilterOperator {
  None = 0,
  In,
  NotIn,
  Like,
  NotLike,
  CaseInsensitiveLike,
  NotCaseInsensitiveLike,
  Equals, // 'eq' + 'isnull' with null value specified + 'isempty' with empty string
  NotEquals, // 'neq' + 'isnotnull' with null value specified + 'isnotempty' with empty string
  CaseInsensitiveEquals,
  NotCaseInsensitiveEquals,
  BeginsWith, // 'startswith'
  NotBeginsWith,
  CaseInsensitiveBeginsWith,
  NotCaseInsensitiveBeginsWith,
  EndsWith, // 'endswith'
  NotEndsWith,
  CaseInsensitiveEndsWith,
  NotCaseInsensitiveEndsWith,
  LessThan, // 'lt'
  NotLessThan,
  LessThanOrEqualTo, // 'lte'
  NotLessThanOrEqualTo,
  GreaterThan, // 'gt'
  NotGreaterThan,
  GreaterThanOrEqualTo, // 'gte'
  NotGreaterThanEqualTo,
  InSubQuery,
  Contains = Like, // 'contains'
  NotContains = NotLike // 'doesnotcontain'
}
